import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../infra/base-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { Plano } from '../interfaces/recarga/recarga.interface';

@Injectable({
  providedIn: 'root'
})

export class RecargaService extends BaseService {

  navegandoParaRecargas: boolean = false;

  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);
  }

  obterTokenRecarga(): Promise<any> {
    return this.post<any>('acesso/tokenrecarga', {});
  }

  async navegarParaRecargas(event: Event, idPlanoPrePago: number = 0): Promise<void> {
      if (event) {
        event.preventDefault();
      }
      
      try {        
        this.navegandoParaRecargas = true;
        this.toastr.info(`Acessando recargas...`);
        const token = await this.obterTokenRecarga();
        const url = `${environment.urlBaseRecarga}/recarga?auth=${token}&idPlanoPrePago=${idPlanoPrePago}&idProduto=${environment.idProduto}`;
        window.open(url, '_blank');
      } catch (error) {
        console.error('Erro ao obter o token de recarga:', error);        
        this.toastr.error(`Não foi possível acessar recarga.`);
      } 
      finally {
        this.navegandoParaRecargas = false;
      }
    }
  
    async navegarParaRelatorios(event: Event): Promise<void> {
      if (event) {
        event.preventDefault();
      }
      
      try {        
        this.navegandoParaRecargas = true;
        this.toastr.info(`Acessando relatórios...`);
        const token = await this.obterTokenRecarga();
        const url = `${environment.urlBaseRecarga}/relatorio?auth=${token}&idProduto=${environment.idProduto}`;
        window.open(url, '_blank');
      } catch (error) {
        console.error('Erro ao obter o token de recarga:', error);        
        this.toastr.error(`Não foi possível acessar relatórios.`);
      } 
      finally {
        this.navegandoParaRecargas = false;
      }
    }


  obterPlanosRecarga(): Promise<Plano[]> {
    return this.get<Plano[]>('acesso/planos');
  }
}


